import { useTheme } from '../../contexts/ThemeContext';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
}

export function GlassCard({ children, className = '' }: GlassCardProps) {
  const { isDark } = useTheme();
  
  return (
    <div className={`
      backdrop-blur-xl shadow-2xl rounded-2xl p-6 transition-all duration-300
      ${isDark 
        ? 'bg-white/5 border border-white/10 hover:bg-white/10 hover:border-white/20' 
        : 'bg-black/5 border border-black/10 hover:bg-black/10 hover:border-black/20'
      }
      ${className}
    `}>
      {children}
    </div>
  );
}

interface FloatingOrbProps {
  className?: string;
  size?: string;
  color?: string;
}

export function FloatingOrb({ 
  className = '', 
  size = 'w-96 h-96',
  color
}: FloatingOrbProps) {
  const { isDark } = useTheme();
  const defaultColor = color || (isDark ? 'bg-blue-500/20' : 'bg-blue-500/10');
  
  return (
    <div className={`
      absolute ${size} ${defaultColor} rounded-full blur-3xl animate-pulse
      ${className}
    `} />
  );
}

interface TechGridProps {
  className?: string;
  opacity?: string;
}

export function TechGrid({ className = '', opacity }: TechGridProps) {
  const { isDark } = useTheme();
  const defaultOpacity = opacity || (isDark ? 'opacity-20' : 'opacity-10');
  
  return (
    <div className={`absolute inset-0 ${defaultOpacity} ${className}`}>
      <div 
        className="w-full h-full"
        style={{
          backgroundImage: `
            linear-gradient(rgba(59, 130, 246, ${isDark ? '0.1' : '0.2'}) 1px, transparent 1px),
            linear-gradient(90deg, rgba(59, 130, 246, ${isDark ? '0.1' : '0.2'}) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }}
      />
    </div>
  );
}